import type { ActionReducerMap } from '@ngrx/store';
import type { DevState } from 'app/store/dev/dev.state';
import { devCouriersReducer } from 'app/store/dev/couriers/couriers.reducer';
import { devDocumentsReducer } from 'app/store/dev/documents/documents.reducer';

export const devReducers: ActionReducerMap<DevState, any> = {
  couriers: devCouriersReducer,
  documents: devDocumentsReducer,
};
